export default {"src":"/polygon/_next/static/media/fund_11.12396d51.svg","height":80,"width":231};